import { regex } from './common'
export default regex('naturalRfc', /^[a-zA-Z0-9ñÑ&-]{13}$/)